import { useFormikContext } from 'formik';

import { isMobile } from 'hooks';
import { EditButtonWithRef } from 'components/specified-buttons';

import { FormValues as CommonFormValues } from '../types';

import { Form } from './form';
import { EditPaymentProps } from './types';

export const EditPayment = ({ data, ...props }: EditPaymentProps) => {
  const mobile = isMobile();
  const { setFieldValue, values: commonValues } =
    useFormikContext<CommonFormValues>();

  return (
    <Form
      {...props}
      isEdit
      data={data}
      trigger={<EditButtonWithRef fullWidth={mobile} />}
      onSubmit={async (values) => {
        const index = commonValues.returnPayments.findIndex(
          (item) => item.id === data.id
        );

        if (index === -1) {
          return;
        }

        const updatedPayments = [...commonValues.returnPayments];
        updatedPayments[index] = values;

        setFieldValue('returnPayments', updatedPayments);
      }}
    />
  );
};
